import apiClient from './apiClient';

export interface ChatMessageExportParams {
  room_type: 'TALK_ROOM' | 'SENIOR_TALK_ROOM' | 'ADMIN_TALK_ROOM' | 'WORKSHOP_ROOM';
  room_id: number;
}

/**
 * チャットメッセージをCSV形式でダウンロード
 */
export const downloadChatMessagesCSV = async(params: ChatMessageExportParams): Promise<void> => {
  try {
    const response = await apiClient.get('/external/chat_messages/csv/', {
      params,
      responseType: 'blob', // レスポンスをBlobとして受け取る
    });
    // Blobを作成
    const blob = new Blob([ response.data as BlobPart ], { type: 'text/csv; charset=utf-8' });
    // ダウンロード用のリンクを作成
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    // ファイル名を生成（レスポンスヘッダーから取得するか、デフォルト値を使用）
    const contentDisposition = response.headers['content-disposition'];
    let filename = `chat_${params.room_type.toLowerCase()}_${params.room_id}_unknown.csv`;
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="(.+)"/);
      if (filenameMatch) {
        filename = filenameMatch[1];
      }
    }
    link.download = filename;
    // リンクをクリックしてダウンロード開始
    document.body.appendChild(link);
    link.click();
    // クリーンアップ
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('CSV download error:', error);
    throw error;
  }
};
/**
 * チャットメッセージ数を取得（将来の拡張用）
 */
export const getChatMessageCount = async(_params: ChatMessageExportParams): Promise<number> => {
  try {
    // 将来的にメッセージ数を返すAPIを追加する場合の準備
    // 現在は実装されていないので、ダミーで0を返す
    return 0;
  } catch (error) {
    console.error('Chat message count fetch error:', error);
    throw error;
  }
};
